<template>
  <NetworkIssuesToast @close="handling = false" />
  <Header :home-route="router.currentRoute.value.name === 'home'" />
  <div :class="{ 'px-4 md:px-24 lg:px-40': !isHomeRoute }">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import Header from '@/components/AppHeader.vue';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import NetworkIssuesToast from './components/NetworkIssuesToast.vue';
import { useNetworkStore } from './stores/network';
import { useToast } from 'primevue/usetoast';
import { useI18n } from 'vue-i18n';

const toast = useToast();
const t = useI18n().t;
const router = useRouter();
const isHomeRoute = computed(() => {
  return router.currentRoute.value.path === '/';
});

const handling = ref(false);
const store = useNetworkStore();
store.$subscribe(() => {
  if (handling.value) {
    return;
  }

  handling.value = true;

  toast.add({
    severity: 'custom',
    summary: t('networkError'),
    detail: t('tryRefresh'),
    group: 'network',
    styleClass: 'backdrop-blur-lg rounded-2xl'
  });
});
</script>
